import React from "react";
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { DateRangePickerProps } from "models/propTypes/datepickerPropTypes";
//#endregion
//#region component
import { Grid } from "@mui/material";
import SimpleDatePicker from "./simpleDatePicker";
//#endregion
import "react-datepicker/dist/react-datepicker.css";
import "theme/custom/react-datepicker.css";

const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
  const { startDate, endDate, setStartDate, setEndDate, onStartBlur, onEndBlur, ...datePickerProps } = props;

  return (
    <Grid container direction="row" spacing={1} className={props.className}>
      <Grid item xs={6}>
        <SimpleDatePicker
          {...datePickerProps}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.From)}
          value={startDate ?? null}
          onChange={setStartDate}
          minDate={props.minStartDate}
          maxDate={props.maxStartDate}
          name={`${props.name}-start`}
          defaultCalendarMonth={props.defaultCalendarMonth ?? endDate}
        />
      </Grid>
      <Grid item xs={6}>
        <SimpleDatePicker
          {...datePickerProps}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.To)}
          value={endDate ?? null}
          onChange={setEndDate}
          minDate={props.minEndDate}
          maxDate={props.maxEndDate}
          name={`${props.name}-end`}
          defaultCalendarMonth={props.defaultCalendarMonth ?? startDate}
        />
      </Grid>
    </Grid>
  );
};
export default DateRangePicker;
